import { render, staticRenderFns } from "./sidebar-resume.vue?vue&type=template&id=0731e09d&"
import script from "./sidebar-resume.vue?vue&type=script&lang=js&"
export * from "./sidebar-resume.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-resume.vue?vue&type=style&index=0&id=0731e09d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports